'use strict';

var React = require('react');
var createStoreProvider = require('./createStoreProvider-55b8195c.js');
var DialogContext = require('./DialogContext-26c9ead4.js');
var SnackbarContext = require('./SnackbarContext-45575d8a.js');
var react = require('@emotion/react');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var useMatchMedia = require('./useMatchMedia-1f69f0f1.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

var DialogProvider = createStoreProvider.createStoreProvider({
  reducer: DialogContext.DialogReducer,
  Provider: DialogContext.DialogContext.Provider,
  initialState: DialogContext.initialState
});

var SnackbarProvider = createStoreProvider.createStoreProvider({
  reducer: SnackbarContext.SnackbarReducer,
  Provider: SnackbarContext.SnackbarContext.Provider,
  initialState: SnackbarContext.initialState
});

var FontProvider = function FontProvider(_ref) {
  var children = _ref.children,
    applyFont = _ref.applyFont;
  var theme = react.useTheme();
  return react.jsx(React.Fragment, null, applyFont && react.jsx(react.Global, {
    styles:
    /*#__PURE__*/
    /*#__PURE__*/
    react.css("body{font-family:", theme.fonts.family, ";}" + ("production" === "production" ? "" : ";label:FontProvider;"), "production" === "production" ? "" : ";label:FontProvider;")
  }), children);
};

var useColorPreference = function useColorPreference() {
  var prefersDark = useMatchMedia.useMatchMedia('(prefers-color-scheme: dark)');
  return prefersDark ? 'dark' : 'light';
};

var ColorSchemes;
(function (ColorSchemes) {
  ColorSchemes["light"] = "light";
  ColorSchemes["dark"] = "dark";
})(ColorSchemes || (ColorSchemes = {}));

var ThemeProvider = function ThemeProvider(_ref) {
  var _ColorSchemes$light$C;
  var children = _ref.children,
    lightTheme = _ref.lightTheme,
    darkTheme = _ref.darkTheme;
  var hasDarkTheme = !!darkTheme;
  var userPreference = useColorPreference();
  var theme = !hasDarkTheme ? lightTheme : (_ColorSchemes$light$C = {}, _defineProperty__default["default"](_ColorSchemes$light$C, ColorSchemes.light, lightTheme), _defineProperty__default["default"](_ColorSchemes$light$C, ColorSchemes.dark, darkTheme), _ColorSchemes$light$C)[userPreference];
  return react.jsx(react.ThemeProvider, {
    theme: theme
  }, children);
};

var Provider = function Provider(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    darkTheme = _ref.darkTheme,
    _ref$applyFont = _ref.applyFont,
    applyFont = _ref$applyFont === void 0 ? false : _ref$applyFont;
  return react.jsx(ThemeProvider, {
    lightTheme: theme,
    darkTheme: darkTheme
  }, react.jsx(FontProvider, {
    applyFont: applyFont
  }, react.jsx(DialogProvider, null, react.jsx(SnackbarProvider, null, children))));
};

exports.Provider = Provider;
//# sourceMappingURL=Provider-65b63bd9.js.map
